var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93 16.416l9.9-9.9 3.656 3.656-9.9 9.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59 20.07l-7.78 2.12 2.12-7.78 12-12a2 2 0 012.83 0l2.83 2.83a2 2 0 010 2.83z",
    fill: "none",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.806 20.777l1.415-1.414 1.414 1.414L3.22 22.19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 2,
    d: "M19.49 10.17l-5.66-5.66"
  })));
}

export default SvgPencil;